import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { useUnifiedCheckout } from "../UnifiedCheckoutProvider.shared";
import { usePaidOrders } from "./usePaidOrders";
import { getOrderStage } from "../../../components";
import { getUnifiedCheckoutDeliveryDates } from "../getUnifiedCheckoutDeliveryDates";

export type UnifiedCheckoutSuccessOrder = {
  order: OrderGetResponseType;
  orderStatus: ReturnType<typeof getOrderStage>;
};

export const useUnifiedCheckoutSuccessPageData = () => {
  const { sdBasket, isLoading: isContextLoading } = useUnifiedCheckout();

  const orderIds = [
    ...new Set([
      ...(sdBasket.paidOrderIds ?? []),
      ...(sdBasket.failedOrderIds ?? []),
      ...(sdBasket.pendingOrderIds ?? []),
    ]),
  ];
  const orderQueries = usePaidOrders(orderIds);

  const orders: UnifiedCheckoutSuccessOrder[] = orderQueries
    .map((query) => {
      const order = query.data;
      if (!order) return null;

      return {
        order,
        orderStatus: getOrderStage(order),
      };
    })
    .filter((item): item is UnifiedCheckoutSuccessOrder => item !== null);

  const loading =
    isContextLoading || orderQueries.some((query) => query.isPending);

  return {
    loading,
    deliveryDates: getUnifiedCheckoutDeliveryDates({
      deliveryPreference: sdBasket.deliveryPreference,
      consolidatedDeliveryDate: sdBasket.deliveryDate,
      supplierDeliveryDates: orders.map(({ order }) => order.deliveryPlannedAt),
    }),
    orders,
    sdBasket,
  };
};
